/**
 * /frontend/src/features/analytics/components/shared/SyncingOverlay.js
 */

import React from 'react';
import './SyncingOverlay.css';

/**
 * Syncing overlay shown while analytics data is being fetched.
 * @param {{message?:string}} props
 * @returns {JSX.Element}
 */
const SyncingOverlay = ({ message }) => (
  <div className="analytics-sync-overlay" aria-busy="true" aria-live="polite">
    <div className="analytics-sync-card">
      <div className="analytics-sync-spinner" aria-hidden="true" />
      <div className="analytics-sync-title">Syncing data</div>
      <div className="analytics-sync-subtitle">{message || 'Fetching latest analytics for the selected range.'}</div>
    </div>
  </div>
);

export default SyncingOverlay;

